// src/constants/i18nNamespaces.js
const namespaces = ["common", "errors", "validations"];

export { namespaces };
